import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { handleBlurOnClick } from "./navbarUtils";

const MobileMenuTrigger = ({ onClick }) => {
    const handleClick = (e) => {
        handleBlurOnClick(e);
        if (onClick) onClick(e);
    };

    return (
        <div
            className="btn btn-ghost xl:hidden p-3 hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 active:bg-gradient-to-r active:from-primary/15 active:to-primary/8 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2 focus:ring-offset-base-100 active:scale-95"
            onClick={handleClick}
        >
            <span className="h-5 w-5 text-base-content hover:text-primary active:text-primary transition-colors duration-300">
                <FontAwesomeIcon icon={faBars} />
            </span>
        </div>
    );
};

export default MobileMenuTrigger;
